const Layout = ({ children }) => (
    <div className="layout active">
        <div className="main-container">
            <main className="main">
                {children}
            </main>
        </div>
        
    </div>
);
export default Layout;